import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren } from "react";
import * as s from "./CategoryList.module.scss";

type CategoryListProps = PropsWithChildren<{
	label?: string;
	withSlider?: boolean;
}>;

/**
 * Use CategoryItem.tsx as children inside this component
 */
const CategoryList: FC<CategoryListProps> = ({
	label,
	withSlider = false,
	children,
}) => {
	return (
		<div className={s.container}>
			{label && (
				<span className={cn({ [s.isSlider]: withSlider })}>{label}</span>
			)}
			<div className={cn(s.wrapper, { [s.slider]: withSlider })}>
				{children}
			</div>
		</div>
	);
};

export default CategoryList;
